import { render, staticRenderFns } from "./caption.vue?vue&type=template&id=8c90deaa&"
import script from "./caption.vue?vue&type=script&lang=js&"
export * from "./caption.vue?vue&type=script&lang=js&"
import style0 from "./caption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports